<div class="{{navbarClass}}">
    <div class="container">
        <nav class="navbar navbar-expand-lg navbar-light">
            <a class="navbar-brand" routerLink="/">
                <img src="assets/img/logo.svg" alt="logo" style="max-width: 160px;">
            </a>

            <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav">
                    <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show"><a routerLink="/"
                            class="nav-link" routerLinkActive="active"
                            [routerLinkActiveOptions]="{exact: true}">Home</a></li>

                    <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show"><a
                            routerLink="/about" class="nav-link" routerLinkActive="active"
                            [routerLinkActiveOptions]="{exact: true}">About Us</a></li>

                    <li class="nav-item">
                        <a routerLink="/services" class="nav-link">Services <i class='bx bx-chevron-down'></i></a>
                        <ul class="dropdown-menu">
                            <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show"><a
                                    routerLink="/website-development" class="nav-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}">Website Development</a></li>

                            <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show"><a
                                    routerLink="/mobile-development" class="nav-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}">Application Development</a></li>

                            <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show"><a
                                    routerLink="/erp-cms" class="nav-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}">ERP/CMS</a></li>

                            <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show"><a
                                    routerLink="/custom-software-development" class="nav-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}">Custom Software Development</a></li>

                            <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show"><a
                                    routerLink="/digital-marketing" class="nav-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}">Digital Marketing</a></li>

                            <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show"><a
                                    routerLink="/hosting-registration" class="nav-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}">Domain & Hosting Registration</a></li>
                        </ul>
                    </li>

                    <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show"><a
                            routerLink="/portfolio" class="nav-link" routerLinkActive="active"
                            [routerLinkActiveOptions]="{exact: true}">Portfolio</a></li>
                    <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show"><a
                            routerLink="/contact" class="nav-link" routerLinkActive="active"
                            [routerLinkActiveOptions]="{exact: true}">Contact Us</a></li>
                </ul>
                <div class="others-options">
                    <a target="_blank" href="https://wa.me/+919601997272?text=I'm%20interested%20in%20your%20services" class="default-btn">
                        <i class='bx bxl-whatsapp'></i>
                        Chat on WhatsApp<span></span>
                    </a>
                </div>
            </div>
        </nav>
    </div>
</div>